import React, { useState, useEffect, useRef } from 'react';
import { Input, InputProps } from 'antd';

interface StableInputProps extends InputProps {
	/** 값이 변경될 때 호출 (한글 조합 완료 시점에만) */
	onStableChange?: (value: string) => void;
}

/**
 * 범용 Input 래퍼
 * - 한글 IME 입력 시 글자 깨짐 방지
 * - 조합 완료(CompositionEnd) 이후에만 onStableChange 호출
 */
const StableInput: React.FC<StableInputProps> = ({
	                                                 onStableChange,
	                                                 value: controlledValue,
	                                                 onChange,
	                                                 ...restProps
                                                 }) => {
	const [innerValue, setInnerValue] = useState<string>(String(controlledValue ?? ''));
	const isComposing = useRef(false);

	// 외부 value 변화 동기화
	useEffect(() => {
		if (controlledValue !== undefined && String(controlledValue) !== innerValue) {
			setInnerValue(String(controlledValue));
		}
	}, [controlledValue]);

	return (
		<Input
			{...restProps}
			value={innerValue}
			onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
				const val = e.target.value;
				setInnerValue(val);
				onChange?.(e);
				if (!isComposing.current) {
					onStableChange?.(val);
				}
			}}
			onCompositionStart={() => {
				isComposing.current = true;
			}}
			onCompositionEnd={(e: React.CompositionEvent<HTMLInputElement>) => {
				isComposing.current = false;
				const val = e.currentTarget.value;
				setInnerValue(val);
				onStableChange?.(val);
			}}
		/>
	);
};

export default StableInput;
